<template>
  <div class="dd-banner" :style="style">
    <div class="dd-banner__text">
      <h2 class="dd-banner__title">{{title}}</h2>
      <p class="dd-banner__desc">{{description}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    image: String
  },
  computed: {
    style () {
      return {
        backgroundImage: `url(${this.image})`
      }
    }
  }
}
</script>

<style lang="scss">
.dd-banner {
  position: relative;
  background: center no-repeat;
  background-size: cover;
  height: 320px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0, .5);
  }
  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
  }
  &__title {
    font-size: 36px;
    line-height: 1.4;
  }
  &__desc {
    width: 366px;
    margin-top: 22px;
    padding-top: 16px;
    font-size: 21px;
    border-top: 1px solid #ccc;
  }
  @include media-tablet {
    height: 193px;

    &__title {
      font-size: 22px;
    }
    &__desc {
      width: auto;
      max-width: 220px;
      margin-top: 13px;
      padding-top: 9px;
      font-size: 13px;
    }
  }
}
</style>
